export default __webpack_public_path__ + "static/Cover-71e7cd096b2a1c7d9d68e91039daeed3.jpg";